/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.common
 */
function scoreBadgeConfig() {
    return {
        restrict: 'E',
        scope: {
            score: "<",
            scoreArray: "<",
            showBadge: "<",
            scaleClass: "<?",
            colorClass: "<?",
            categoryId: "<?",
        },
        bindToController: true,
        controller: scoreBadgeController,
        controllerAs: 'vm',
        template: require('./scoreBadgeView.html'),
    };

}

scoreBadgeController.$inject = ['$scope', '$stateParams', 'UtilService', 'CategoriesService'];
function scoreBadgeController ($scope, $stateParams, UtilService, CategoriesService) {
    this.$onInit = function () {
        const vm = this;
        const defaultEfficiencyThreshold = 90;
        const isEfficientThreshold = UtilService.getSiteSetting('is_efficient_threshold', defaultEfficiencyThreshold);

        vm.categoryId = vm.categoryId || CategoriesService.getCategoryIdByCode($stateParams.category_code);
        const displayScore = UtilService.getCategorySetting(vm.categoryId, 'display_score', true);

        // scoreArray is used to render an icon for each digit of the score
        vm.scoreArray = [];
        vm.showBadge = false;

        $scope.$watch('vm.score', function (newScore) {
            if (typeof newScore === 'number' && displayScore) {
                vm.scoreArray = newScore.toString().split('');
                vm.showBadge = true;
            };

            // In addition to the score, we also want the score color
            // to remain updated for features like the ecoview slider.
            vm.colorClass = newScore >= isEfficientThreshold ? 'is-ideal' : '';
        });
    };
}

module.exports = scoreBadgeConfig;
